module.exports = __webpack_public_path__ + "img/icon_point.cb5aa82b.svg";